import { render, staticRenderFns } from "./PopupDownloadDocument.vue?vue&type=template&id=0f6d24e0"
import script from "./PopupDownloadDocument.vue?vue&type=script&lang=js"
export * from "./PopupDownloadDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports